// @flow
import React, { PureComponent, type Node } from 'react';
import { get, isEmpty } from 'lodash';
import classnames from 'classnames';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './BlockLink.themes';

export type BlockLinkProps = {
  className?: string,
  icon: IconName,
  secondaryTexts?: Array<string>,
  target?: string,
  texts: $ReadOnlyArray<string | Node>,
  theme?: string,
  url: string,
  onClick?: *,
  trackingData?: TrackingData,
};

export class BlockLink extends PureComponent<BlockLinkProps> {
  static defaultProps = {
    target: '_blank',
    theme: 'default',
    onClick: () => {},
  };

  renderTexts(texts: Array<string> = [], classes: string = ''): Array<Node> {
    const { theme } = this.props;

    return texts.filter(text => !isEmpty(text)).map((text, idx) => (
      <div
        className={classnames(
          `BlockLink-text-${idx}`,
          classes,
          get(themes[theme], `customText${idx}`, ''),
        )}
        data-testid="BlockLink-text"
        key={idx}
      >
        {text}
      </div>
    ));
  }

  render() {
    const {
      className,
      icon,
      onClick,
      secondaryTexts,
      target,
      texts,
      theme,
      trackingData,
      url = '',
    } = this.props;

    const title = (texts || []).filter(t => typeof t === 'string').join(' ');
    const linkTarget = url.startsWith('tel:') ? '' : target;

    const { thIcon, thIconWidth, thRoot, thSText } = themes[theme];

    const classes = classnames(className, thRoot);

    return !isEmpty(texts) || icon ? (
      <TrackClick
        as="a"
        className={classes}
        href={url}
        onClick={onClick}
        rel="noopener noreferrer"
        target={linkTarget}
        title={title}
        trackingData={trackingData}
      >
        <Icon className={classnames('flex-shrink-0', thIcon)} name={icon} width={thIconWidth} />
        {!isEmpty(texts) && (
          <span>
            {this.renderTexts(texts)}
            {this.renderTexts(secondaryTexts, thSText)}
          </span>
        )}
      </TrackClick>
    ) : null;
  }
}
